export const hexToRgb = (hex: string) => {
  const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex);
  return result
    ? `${Number.parseInt(result[1], 16)},
    ${Number.parseInt(result[2], 16)},
    ${Number.parseInt(result[3], 16)}`
    : null;
};
